package `fun`.adaptive.adaptive_lib_app.generated.resources

import `fun`.adaptive.resource.graphics.Graphics
import `fun`.adaptive.resource.graphics.GraphicsResource
import `fun`.adaptive.resource.graphics.GraphicsResourceSet

private object commonMainGraphics0 {

    val pest_control by lazy { init_pest_control() }

    val supervised_user_circle by lazy { init_supervised_user_circle() }

    val gpp_maybe by lazy { init_gpp_maybe() }

    val military_tech by lazy { init_military_tech() }

    val lock by lazy { init_lock() }

    val group by lazy { init_group() }

    val lock_open by lazy { init_lock_open() }

    val add by lazy { init_add() }

    val check_circle by lazy { init_check_circle() }

    val sell by lazy { init_sell() }

    val edit by lazy { init_edit() }

    val local_police by lazy { init_local_police() }

    val eco by lazy { init_eco() }

}

val Graphics.pest_control
    get() = commonMainGraphics0.pest_control

private fun init_pest_control() =
    GraphicsResourceSet(
        name = "pest_control",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/pest_control.svg", setOf())
    )

val Graphics.supervised_user_circle
    get() = commonMainGraphics0.supervised_user_circle

private fun init_supervised_user_circle() =
    GraphicsResourceSet(
        name = "supervised_user_circle",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/supervised_user_circle.svg", setOf())
    )

val Graphics.gpp_maybe
    get() = commonMainGraphics0.gpp_maybe

private fun init_gpp_maybe() =
    GraphicsResourceSet(
        name = "gpp_maybe",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/gpp_maybe.svg", setOf())
    )

val Graphics.military_tech
    get() = commonMainGraphics0.military_tech

private fun init_military_tech() =
    GraphicsResourceSet(
        name = "military_tech",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/military_tech.svg", setOf())
    )

val Graphics.lock
    get() = commonMainGraphics0.lock

private fun init_lock() =
    GraphicsResourceSet(
        name = "lock",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/lock.svg", setOf())
    )

val Graphics.group
    get() = commonMainGraphics0.group

private fun init_group() =
    GraphicsResourceSet(
        name = "group",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/group.svg", setOf())
    )

val Graphics.lock_open
    get() = commonMainGraphics0.lock_open

private fun init_lock_open() =
    GraphicsResourceSet(
        name = "lock_open",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/lock_open.svg", setOf())
    )

val Graphics.add
    get() = commonMainGraphics0.add

private fun init_add() =
    GraphicsResourceSet(
        name = "add",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/add.svg", setOf())
    )

val Graphics.check_circle
    get() = commonMainGraphics0.check_circle

private fun init_check_circle() =
    GraphicsResourceSet(
        name = "check_circle",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/check_circle.svg", setOf())
    )

val Graphics.sell
    get() = commonMainGraphics0.sell

private fun init_sell() =
    GraphicsResourceSet(
        name = "sell",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/sell.svg", setOf())
    )

val Graphics.edit
    get() = commonMainGraphics0.edit

private fun init_edit() =
    GraphicsResourceSet(
        name = "edit",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/edit.svg", setOf())
    )

val Graphics.local_police
    get() = commonMainGraphics0.local_police

private fun init_local_police() =
    GraphicsResourceSet(
        name = "local_police",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/local_police.svg", setOf())
    )

val Graphics.eco
    get() = commonMainGraphics0.eco

private fun init_eco() =
    GraphicsResourceSet(
        name = "eco",
        GraphicsResource("/fun.adaptive.adaptive_lib_app.generated.resources/graphics/eco.svg", setOf())
    )